@import "@/scss/use-bootstrap-mixins";

.descriptionsInclusions {
  font-size: 13px;
  font-weight: 600 !important;
}

.description {
  display: flex;
  margin-bottom: 32px;
  flex-wrap: wrap;
  width: 100%;

  .inclusion {
    width: 50%;
    display: flex;
    padding-right: 5px;
    align-items: center;

    .tick {
      display: flex !important;
      flex-shrink: 0;
      svg {
        width: 13px;
        height: 9px;
        margin-right: 13px;
        stroke: $textColorOnPrimary;
      }
    }

    .text {
      font-size: 12px;
      font-weight: 400;
    }
  }
}
